<template>
  <v-container>
    <v-row>
      <v-col
        v-if="value.title || value.description"
        :class="
          value.center_align === 'auto'
            ? 'text-center text-lg-left'
            : value.center_align === 'always'
              ? 'text-center'
              : ''
        "
        cols="12"
        lg=""
      >
        <h2
          v-if="value.title"
          :class="value.description ? 'mb-4' : ''"
          class="text-h5 text-sm-h4"
        >
          <StyledText
            :value="value.title"
            :em-class="
              value.color_scheme && value.color_scheme.em_text_color
                ? `text-${value.color_scheme.em_text_color.id} font-weight-medium`
                : `text-light-blue-darken-2 font-weight-medium`
            "
          />
          <ShareLinkButton
            v-if="showShareLink"
            :hash="'#' + slugify(value)"
            position="absolute"
            variant="text"
          />
        </h2>

        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="value.description"
          class="text-body-0"
          v-html="value.description"
        ></div>

        <div v-if="ctas && ctas.length">
          <CtaButton
            v-for="(cta, i) in ctas"
            :key="cta.id"
            :class="i < ctas.length - 1 ? 'mr-6' : ''"
            :primary-color="
              value.color_scheme && value.color_scheme.primary_button_color
                ? value.color_scheme.primary_button_color.id
                : undefined
            "
            :secondary="i > 0"
            :secondary-color="
              value.color_scheme && value.color_scheme.secondary_button_color
                ? value.color_scheme.secondary_button_color.id
                : undefined
            "
            :value="cta.ctas_id"
            class="text-none my-3"
            rounded="pill"
          />
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { computed } from 'vue'
import { slugify } from '#root/lib/utils'
import { useShowShareLink } from '#root/lib/useShowShareLink'

const props = defineProps({
  value: {
    required: true,
    type: Object
  }
})

const { showShareLink } = useShowShareLink()

const ctas = computed(() => {
  return (
    props.value &&
    props.value.ctas &&
    props.value.ctas.filter(cta => cta.ctas_id.status === 'published')
  )
})
</script>
